import { z } from 'zod';

export const GetReverseProposalServiceRequestSchema = z
  .object({
    reverseProposalId: z.number(),
  })
  .describe('GetReverseProposalServiceRequestSchema');

export type GetReverseProposalServiceRequest = z.infer<
  typeof GetReverseProposalServiceRequestSchema
>;

const ReverseProposalStatusSchema = z.enum(['WAITING', 'APPROVED', 'REJECTED']);

const GoodsSchema = z.object({
  goodsNo: z.number(),
  imageUrl: z.string(),
  brandName: z.string(),
  goodsName: z.string(),
  salesRate: z.number(),
  price: z.number(),
  isSoldOut: z.boolean(),
});

export type ReverseProposalGoods = z.infer<typeof GoodsSchema>;

export const GetReverseProposalServiceResponseSchema = z.object({
  campaignReverseProposalId: z.number(),
  brandImageUrl: z.string(),
  status: ReverseProposalStatusSchema,
  brandName: z.string(),
  createdAt: z.string(),
  startAt: z.string(),
  goods: GoodsSchema,
  curatorCouponCampaignProposalId: z.number().nullable().optional(),
});

export type GetReverseProposalServiceResponse = z.infer<
  typeof GetReverseProposalServiceResponseSchema
>;
